<template>
    <div>
        <b-card tag="article" style="max-width: 100%;" class="mb-2">
            <div class="card-text">
                <b-row>
                    <b-col xs="12" md="12" lg="6">
                        <app-date-time-picker
                            id="departureDate"
                            :withTime="false"
                            label="Fecha de salida"
                            v-model="theEntry.departureDate"
                            :required="true"
                            :hasError="$v.theEntry.departureDate.$error"
                            error-message="Debe especificar la fecha y hora de salida"
                            :max-date="moment().toDate()"
                        />
                    </b-col>
                    <b-col xs="12" md="12" lg="6">
                        <label
                            >Hora de salida
                            <span class="field-required-mark">*</span></label
                        >
                        <b-form-input
                            id="type"
                            type="time"
                            v-model="theEntry.checkOut"
                        ></b-form-input>
                        <span
                            class="field-error"
                            v-if="$v.theEntry.checkOut.$error"
                        >
                            Debe especificar la hora</span
                        >
                        <br />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" md="12" lg="7">
                        <app-autocomplete
                            placeholder="Conductor"
                            :items="drivers"
                            v-model="theEntry.selectedDriver"
                        />
                    </b-col>
                    <b-col cols="12" md="5" lg="5">
                        <b-button
                            size="sm"
                            variant="outline-primary"
                            class="btn-block"
                            @click="newDriver"
                            v-b-toggle.collapse-3
                            >Nuevo conductor</b-button
                        >
                    </b-col>
                </b-row>
                <b-collapse id="collapse-3">
                    <b-row>
                        <b-col cols="12" md="12" lg="12">
                            <b-card>
                                <b-row>
                                    <b-col cols="12" md="12" lg="6">
                                        <app-form-text-input
                                            label="Documento conductor"
                                            id="driverDocument1"
                                            :required="true"
                                            :hasError="
                                                $v.theEntry.driverDocument
                                                    .$error
                                            "
                                            errorMessage="Debe escribir el documento del conductor"
                                            @input="
                                                $v.theEntry.driverDocument.$touch()
                                            "
                                            v-model="theEntry.driverDocument"
                                        >
                                        </app-form-text-input>
                                    </b-col>
                                    <b-col cols="12" md="12" lg="6">
                                        <app-form-text-input
                                            label="Nombre conductor"
                                            id="driverName"
                                            :required="true"
                                            :hasError="
                                                $v.theEntry.driverName.$error
                                            "
                                            errorMessage="Debe escribir el nombre del conductor"
                                            @input="
                                                $v.theEntry.driverName.$touch()
                                            "
                                            v-model="theEntry.driverName"
                                        >
                                        </app-form-text-input>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-col>
                    </b-row>
                    <br />
                </b-collapse>
                <b-row>
                    <b-col cols="12" md="12" lg="12">
                        <app-form-text-input
                            label="Peso de salida (Toneladas)"
                            id="finalWeight"
                            :required="true"
                            v-model="theEntry.finalWeight"
                            :hasError="$v.theEntry.finalWeight.$error"
                            errorMessage="debe escribir un número valido"
                            @input="$v.theEntry.finalWeight.$touch()"
                        >
                        </app-form-text-input>
                    </b-col>
                    <b-col cols="12" md="12" lg="12">
                        <br />
                        <app-form-textarea-input
                            label="Notas de salida"
                            id="entryNotes"
                            v-model="theEntry.departureNotes"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" md="6" lg="6">
                        <b-btn
                            v-b-toggle.collapse1
                            variant="primary"
                            class="btn-block"
                            ><i class="fa fa-plus" aria-hidden="true"></i>
                            Agregar fotos</b-btn
                        >
                    </b-col>
                </b-row>
                <b-collapse id="collapse1" class="mt-2">
                    <b-row>
                        <b-col cols="12" md="12" lg="12">
                            <b-card>
                                <div class="card-text">
                                    <app-upload-or-take-photo
                                        id="cargo-vehicle-departure-photos"
                                        title="Fotos de vehículo de carga"
                                        v-model="files"
                                    />
                                    <div
                                        v-if="files.files && files.files.length"
                                    >
                                        <button
                                            class="btn btn-sm btn-danger pull-right"
                                            @click="cancelFilesSelected"
                                        >
                                            <i
                                                class="fa fa-trash-o"
                                                aria-hidden="true"
                                            ></i>
                                            Cancelar archivos seleccionados
                                        </button>
                                    </div>
                                </div>
                            </b-card>
                        </b-col>
                    </b-row>
                </b-collapse>
            </div>
        </b-card>
    </div>
</template>
<script>
import Autocomplete from '../../../../../../components/UI/Controls/AutocompleteV2/Autocomplete.vue'
import { required } from 'vuelidate/lib/validators'
import { decimal } from '../../../../../../utils/CustomValidators'
import UploadOrTakePhoto from '../../../../../UI/Controls/Photos/UploadOrTakePhoto.vue'
import cargoVehicleEntriesRepository from '../../../../../../repositories/cargoVehicleEntries.repository'
export default {
    components: {
        appAutocomplete: Autocomplete,
        appUploadOrTakePhoto: UploadOrTakePhoto,
    },
    props: {
        onSave: {
            type: Function,
        },
        myEntry: {
            required: true,
        },
    },

    data() {
        return {
            theEntry: {
                departureNotes: '',
                departureDate: '',
                finalWeight: '',
                driverDocument: '',
                driverName: '',
                selectedDriver: '',
                checkOut: '',
            },
            files: '',
            drivers: [],
            isNewDriver: false,
        }
    },
    validations: {
        theEntry: {
            driverName: { required },
            driverDocument: { required },
            departureDate: { required },
            checkOut: { required },
            finalWeight: { decimal, required },
        },
    },

    watch: {
        'theEntry.selectedDriver'(val) {
            if (val) {
                this.theEntry.driverName = val.name
                this.theEntry.driverDocument = val.document
                this.isNewDriver = false
            } else {
                this.isNewDriver = true
            }
        },
        myEntry(val) {
            this.setAutoDateTime()
            this.loadCargoDrivers()
        },
    },
    methods: {
        newDriver() {
            this.isNewDriver = true
            this.theEntry.selectedDriver = ''
            this.theEntry.driverDocument = ''
            this.theEntry.driverName = ''
        },
        registerDeparture() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }

            const formData2 = new FormData()

            formData2.append('departureRegisteredById', this.user.id)
            formData2.append('departureNotes', this.theEntry.departureNotes)
            formData2.append('finalWeight', this.theEntry.finalWeight)
            formData2.append('departureDate', this.theEntry.departureDate)
            formData2.append('isNewDriver', !!this.isNewDriver ? 1 : 0)
            formData2.append('checkOut', this.theEntry.checkOut)

            if (!this.isNewDriver) {
                formData2.append('driverId', this.theEntry.selectedDriver.id)
            } else {
                formData2.append('driverDocument', this.theEntry.driverDocument)
                formData2.append('driverName', this.theEntry.driverName)
            }

            if (this.files.photos) {
                this.files.photos.map(item =>
                    formData2.append('photos[]', item)
                )
            }
            if (this.files.files) {
                this.files.files.map((item, index) =>
                    formData2.append('file' + index, item)
                )
            }

            const cver = { ...cargoVehicleEntriesRepository }
            cver.registerDeparture(formData2, this.myEntry.id)
                .then(({ data }) => {
                    if (data.status) {
                        toastr.success(data.msg)
                        this.cleanForm()
                        typeof this.onSave === 'function' && this.onSave()
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch(error => {
                    toastr.error(
                        'Ocurrió un error al guardar la salida del vehículo de carga'
                    )
                })
        },
        loadCargoDrivers() {
            const cver = { ...cargoVehicleEntriesRepository }
            cver.loadCargoVehicleDrivers({ client: this.client.id })
                .then(({ data }) => (this.drivers = data))
                .catch(error =>
                    toastr.error('Ocurrió un error al cargar los conductores')
                )
        },
        cleanForm() {
            Object.keys(this.theEntry).map(key => (this.theEntry[key] = ''))
            this.$nextTick(() => {
                this.$v.$reset()
            })
            this.$bus.$emit('cargo-vehicle-departure-photos.clean')
        },
        cancelFilesSelected() {
            this.$bus.$emit('cargo-vehicle-departure-photos.clean')
            this.files = ''
            toastr.success('Archivos cancelados')
        },
        setAutoDateTime() {
            this.theEntry.departureDate = moment().format('YYYY-MM-DD')
            this.theEntry.checkOut = moment().format('HH:mm')
        },
        initialize() {
            this.loadCargoDrivers()
        },
    },
    created() {
        this.$bus.$on(
            'cargo-vehicle-departure-form.save',
            this.registerDeparture
        )
        this.$bus.$on('cargo-vehicle-departure-form.clean', this.cleanForm)
    },
    mounted() {
        this.initialize()
        this.setAutoDateTime()
    },
    beforeDestroy() {
        this.$bus.$off('cargo-vehicle-departure-form.save')
    },
}
</script>
